import { BehavioralFactor } from '../../core-data-model/BehavioralFactor.model';
import { MinMax } from '../../core-data-model/Common.model';

export type FactorEntry = {
    key: BehavioralFactor;
    left: string;
    right: string;
    height: number;
};

export type DraggableOnMousedown = (
    factor: BehavioralFactor,
    isRight: boolean
) => () => void;

type DragStartEnd = {
    start: number;
    end: number;
};

export type DragStartEndMap = {
    [key: string]: DragStartEnd;
    A: DragStartEnd;
    B: DragStartEnd;
    C: DragStartEnd;
    D: DragStartEnd;
};

const gradientColors = ['#fcc18c', '#f47641'];

export const config = {
    gradientColors,
    draggableRectWidth: 50,
    rectOffset: 25,
    rectHeight: 36,
    xAxisBounds: new MinMax({
        min: 0,
        max: 1097.67
    }),

    draggableRectStyle: {
        fill: 'transparent',
        cursor: 'col-resize'
    },

    rangeRectStyle: {
        fill: '#ff773d',
        'fill-opacity': 0.1,
        stroke: gradientColors[1],
        strokeWidth: 1.5
    },

    rangeRectThickStyle: {
        fill: '#ff773d',
        'fill-opacity': 0.1,
        stroke: gradientColors[1],
        strokeWidth: 6.0
    },

    sigmaLineStyle: {
        fill: 'none',
        stroke: '#c8caca',
        strokeMiterlimit: 10,
        strokeWidth: '1.18743134819734px'
    },

    activeLabel: {
        fill: '#272626'
    },
    inactiveLabel: {
        fill: '#c8caca'
    },

    tickMarkStyle: {
        fill: 'none',
        stroke: '#fff',
        strokeMiterlimit: 10,
        strokeWidth: '1.51967823185229px'
    }
};
